import Vue from "vue";
import Router from "vue-router";
import store from "./Store/index";
// import axios from "axios";

import Home from "./components/HelloWorld";
import Login from "./components/Login";
import LoginAdmin from "./components/LoginAdmin";
import LoginBank from "./components/LoginBank";
import ResetPassword from "./components/ResetPassword";
import ReLogin from "./components/ReLogin";
import Register from "./components/Register";
import RegisterDataPribadi from "./components/RegisterDataPribadi";
import RegisterDataPekerjaan from "./components/RegisterDataPekerjaan";
import RegisterDataKeuangan from "./components/RegisterDataKeuangan";
import RegisterDataRekening from "./components/RegisterDataRekening";
import RegisterDataKontak from "./components/RegisterDataKontak";
import RegisterDataLampiran from "./components/RegisterDataLampiran";
import Preview from "./components/Preview";
import Dashboard from "./components/Dashboard";
import KonfirmasiGiro from "./components/KonfirmasiGiro";
import Statistic from "./components/Statistic";
import PosGold from "./components/PosGold";
import Activation from "./components/Activation";
import LoginPosgold from "./components/LoginPosgold";
import Profile from "./components/Profil";
import Admin from "./components/admin/DsbAdmin";
import NsbBaru from "./components/admin/NsbBaru";
import NsbBlackList from "./components/admin/NsbBlackList";
import NsbReject from "./components/admin/NsbReject";
import NsbTerdaftar from "./components/admin/NsbTerdaftar";
import NsbDetail from "./components/admin/NsbDetail";
import NsbVideo from "./components/admin/NsbVideoCall";
import Headers from "./components/Header";
import PageNotFound from "./components/PageNotfound";
import JoinVideo from "./components/JoinVideo";
import Waiting from "./components/WaitingVerifikasi";
import Welcome from "./components/WelcomingPage";
import InputResetPassword from "./components/ResetPasswordInput";
import ExternalPlatform from "./components/admin/EksternalPlatform";
import ExternalRegister from "./components/admin/EpTerdaftar";
import AuditTrail from "./components/admin/AuditTrail";
import KonfirmasiWakilPialang from "./components/KonfirmasiWakilPialang";

Vue.use(Router);

// const role = store.getters.role;
// const kyc = localStorage.getItem("kyc");
// const kyc_state = localStorage.getItem("kyc_state");
// const status_kyc = localStorage.getItem("status_kyc");
// const platform = localStorage.getItem("platform");

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next();
    // if (role == 2) {
    //   next("/dashboard");
    // } else if (role == 5 || role == 6) {
    //   next("/admin");
    // } else if (kyc == 205) {
    //   next("/register-waiting");
    // } else {
    //   if (kyc_state) {
    //     if (status_kyc == "open") {
    //       if (kyc_state == "employment") {
    //         next("/register-datapekerjaan");
    //       } else if (kyc_state == "financial") {
    //         next("/register-datakeuangan");
    //       } else if (kyc_state == "customer_account") {
    //         next("/register-datarekening");
    //       } else if (kyc_state == "emergency_contact") {
    //         next("/register-datakontak");
    //       } else if (kyc_state == "attachment") {
    //         next("/register-datalampiran");
    //       } else if (kyc_state == "customer" || platform === "GoFX" || platform === "Jafets") {
    //         next("/register-datapribadi");
    //       } else if (kyc_state == "full") {
    //         next("register-preview");
    //       } else {
    //         next("/register-datapribadi");
    //       }
    //     } else if (status_kyc == "submitted" || status_kyc == "full") {
    //       next("/register-waiting");
    //     } else if (status_kyc == "reject") {
    //       next("login-bank");
    //     } else {
    //       next("register-datapribadi");
    //     }
    //   } else {
    //     next("register-datapribadi");
    //   }
    // }
};

// const authUser = (to, from, next) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     if (role == "1") {
//       next();
//     } else {
//       localStorage.clear();
//       delete axios.defaults.headers.common["Authorization"];
//       next("/login");
//     }
//   } else {
//     next("/login");
//   }
// };

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/login");
};
const ifAuthAdmin = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/login-admin");
};

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: "history",
    routes: [
        { path: "/", component: Home, beforeEnter: ifNotAuthenticated },
        {
            path: "/admin-layout",
            component: () => import("./layout/AdminLayout.vue"),
            beforeEnter: ifAuthenticated,
            children: [
                {
                    path: "/deposit",
                    component: () => import("./components/Deposit.vue"),
                },
                {
                    path: "/witdrawal",
                    component: () => import("./components/Withdrawal.vue"),
                },
                { path: "/profil", component: Profile },
            ],
        },
        { path: "/home", component: () => import("./components/Home.vue") },
        { path: "/register", component: Register },
        { path: "/login", component: Login, beforeEnter: ifNotAuthenticated },
        { path: "/login-admin", component: LoginAdmin, beforeEnter: ifNotAuthenticated },
        { path: "/bank-login", component: LoginBank, beforeEnter: ifNotAuthenticated },
        { path: "/confirm-resetpassword/:id", component: InputResetPassword },
        { path: "/resetpassword", component: ResetPassword },
        { path: "/konfirmasi-pialang", component: KonfirmasiWakilPialang },
        {
            path: "/",
            component: () => import("./layout/UserLayout.vue"),
            beforeEnter: ifAuthenticated,
            children: [
                {
                    path: "/konfirmasi-akun",
                    component: KonfirmasiGiro,
                },
                {
                    path: "/profil-perusahaan",
                    component: () => import("./components/RegisterProfilPialang.vue"),
                },
                {
                    path: "/simulasi",
                    component: () => import("./components/RegisterSimulasi.vue"),
                },
                {
                    path: "/investment-experience",
                    component: () => import("./components/RegisterPengalaman.vue"),
                },
                {
                    path: "/amanat",
                    component: () => import("./components/RegisterPemberianAmanat.vue"),
                },
                {
                    path: "/resiko",
                    component: () => import("./components/RegisterPemberitahuanResiko.vue"),
                },
                {
                    path: "/kode-akses",
                    component: () => import("./components/RegisterKodeAkses.vue"),
                },
                {
                    path: "/disclosure1",
                    component: () => import("./components/RegisterDisclosure.vue"),
                    alias: ["/disclosure2", "/disclosure3"],
                },
                {
                    path: "/verification-page",
                    component: () => import("./components/RegisterKelengkapan.vue"),
                    alias: ["/disclosure2", "/disclosure3"],
                },
                {
                    path: "/login-bank",
                    component: LoginPosgold,
                },
                {
                    path: "/register-datapribadi",
                    component: RegisterDataPribadi,
                },
                {
                    path: "/register-datapekerjaan",
                    component: RegisterDataPekerjaan,
                },
                {
                    path: "/register-datakeuangan",
                    component: RegisterDataKeuangan,
                },
                {
                    path: "/register-datarekening",
                    component: RegisterDataRekening,
                },
                {
                    path: "/register-datakontak",
                    component: RegisterDataKontak,
                },
                {
                    path: "/register-datalampiran",
                    component: RegisterDataLampiran,
                },
                {
                    path: "/register-preview",
                    component: Preview,
                },
                {
                    path: "/register-waiting",
                    component: Waiting,
                },
            ],
        },
        {
            path: "",
            component: Headers,
            beforeEnter: ifAuthAdmin,
            children: [
                { path: "/relogin", component: ReLogin },
                { path: "/video-call/:id", component: JoinVideo },
                {
                    path: "",
                    component: Dashboard,
                    children: [
                        { path: "/dashboard", component: Statistic },
                        { path: "/posgold", component: PosGold },
                        { path: "/admin", component: Admin },
                        { path: "/nsb-baru", component: NsbBaru },
                        { path: "/nsb-blacklist", component: NsbBlackList },
                        { path: "/nsb-reject", component: NsbReject },
                        { path: "/nsb-terdaftar", component: NsbTerdaftar },
                        { path: "/nsb-deposit", component: () => import("./components/admin/NsbDeposit.vue") },
                        { path: "/nsb-withdrawal", component: () => import("./components/admin/NsbWithdrawal.vue") },
                        { path: "/nsb-video-call", component: NsbVideo },
                        { path: "/nsb-detail/:id", component: NsbDetail },
                        { path: "/nsb-eksternal", component: ExternalPlatform },
                        { path: "/esp-terdaftar", component: ExternalRegister },
                        { path: "/audit-trail", component: AuditTrail },
                        { path: "/list-user", component: () => import("./components/superAdmin/ListUser.vue") },
                    ],
                    // beforeEnter: ifAuthenticated,
                },
            ],
        },
        { path: "/trading-jfx", component: () => import("./assets/filedownload/TradingJfx.vue") },
        { path: "/aktivasi/:id", component: Activation },
        { path: "/welcome", component: Welcome },
        { path: "/confirmation-user/:id", component: () => import("./assets/filedownload/Confirmation_User.vue") },
        { path: "*", component: PageNotFound },
    ],
});
